class CountdownManager {
    _selectorClass = '.js-Countdown';
    _interval;
    _instances = [];
    static _createCountdownInstance(node) {
        const prefixDataAttr = 'data-countdown-';
        return {
            node,
            date: new Date(node.attr(prefixDataAttr + 'date')),
            days: {
                singular: node.attr(prefixDataAttr + 'days'),
                plural: node.attr(prefixDataAttr + 'days-plural')
            },
            hours: {
                singular: node.attr(prefixDataAttr + 'hours'),
                plural: node.attr(prefixDataAttr + 'hours-plural')
            },
            minutes: {
                singular: node.attr(prefixDataAttr + 'minutes'),
                plural: node.attr(prefixDataAttr + 'minutes-plural')
            },
            seconds: {
                singular: node.attr(prefixDataAttr + 'seconds'),
                plural: node.attr(prefixDataAttr + 'seconds-plural')
            }
        };
    }
    static _renderLabel(value, label) {
        return value === 1 ? label.singular : label.plural;
    }
    static _renderDigit(number, label) {
        const digit = (number < 10 ? '0' : '') + number;
        const digits = digit.split('')
            .map(d => `<span>${d}</span>`)
            .join('');
        return `
      <span class="Countdown__Digits">${digits}</span>
      <span class="Countdown__Label">${CountdownManager._renderLabel(number, label)}</span>
    `;
    }
    init() {
        const elements = $(this._selectorClass);
        if (!elements.length)
            return;
        elements.each((index, element) => {
            this._instances.push(CountdownManager._createCountdownInstance($(element)));
            this._interval = window.setInterval(this.tick.bind(this), 1000);
        });
    }
    tick() {
        this._instances.forEach(instance => {
            const now = new Date().getTime();
            const distance = instance.date.getTime() - now;
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);
            const html = `
      <ul class="Countdown">
        <li class="Countdown__Part">
            ${CountdownManager._renderDigit(days >= 0 ? days : 0, instance.days)}
        </li>
        <li class="Countdown__Part">
            ${CountdownManager._renderDigit(hours >= 0 ? hours : 0, instance.hours)}
        </li>
        <li class="Countdown__Part">
            ${CountdownManager._renderDigit(minutes >= 0 ? minutes : 0, instance.minutes)}
        </li>
        <li class="Countdown__Part">
            ${CountdownManager._renderDigit(seconds >= 0 ? seconds : 0, instance.seconds)}
        </li>
      </ul>
    `;
            const htmlStripped = html.replace(/\s+/g, ' ');
            instance.node.html(htmlStripped);
            const isThePast = [days, hours, minutes, seconds].some(number => number < 0);
            if (isThePast)
                this.destroy();
        });
    }
    destroy() {
        window.clearInterval(this._interval);
    }
}
const countdownManager = new CountdownManager();
export { CountdownManager, countdownManager };
